import { computed } from 'vue';
import type { ComputedRef, Ref } from 'vue';
import type { SmsAiDraftLocale } from '@/components/sms/aiDraft/types.ts';

interface UseSmsAiDraftEntitlementOptions {
    entitled: Ref<boolean>;
    serviceLead: Ref<boolean>;
    leadLocale: Ref<string | undefined>;
}

interface UseSmsAiDraftEntitlement {
    canGenerate: ComputedRef<boolean>;
    serviceLeadDisabled: ComputedRef<boolean>;
    showEntryPoint: ComputedRef<boolean>;
    locale: ComputedRef<SmsAiDraftLocale>;
}

export const useSmsAiDraftEntitlement = ({
    entitled,
    serviceLead,
    leadLocale,
}: UseSmsAiDraftEntitlementOptions): UseSmsAiDraftEntitlement => {
    const isEntitled = computed<boolean>(() => entitled.value);

    const isServiceLead = computed<boolean>(() => serviceLead.value);

    const canGenerate = computed<boolean>(() => isEntitled.value && !isServiceLead.value);

    const serviceLeadDisabled = computed<boolean>(() => isEntitled.value && isServiceLead.value);

    const showEntryPoint = computed<boolean>(() => isEntitled.value);

    const locale = computed<SmsAiDraftLocale>(() => (leadLocale.value === 'fr' ? 'fr' : 'en'));

    return {
        canGenerate,
        locale,
        serviceLeadDisabled,
        showEntryPoint,
    };
};
